RivalIQ.module('postTags.data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const PostTagsCacheLayer = RivalIQ.data.CacheLayer.extend({
        name: 'PostTags',
        cacheKeys: [],

        loadData: function () {
            const collection = new App.postTags.collections.PostTags();
            return collection.fetch();
        },

        onPostTagCreated: function (postTag) {
            const me = this;

            RivalIQ.postTags.data.PostTags.invalidateCaches();
            me.trigger('postTag:created', postTag);
        },

        onPostTagChanged: function (postTag) {
            const me = this;

            RivalIQ.postTags.data.PostTags.invalidateCaches();
            me.trigger('postTag:changed', postTag);
        },

        onPostTagDeleted: function (postTag) {
            const me = this;

            RivalIQ.postTags.data.PostTags.invalidateCaches();
            RivalIQ.apps.SocialPosts.data.invalidateAllSocialPostsCaches();
            RivalIQ.apps.Insights.data.post.invalidateCaches();
            me.trigger('postTag:deleted', postTag);
        }
    });

    data.PostTags = new PostTagsCacheLayer();

    data.PostTags.updateAssociations = function (postTagsToAdd, postTagsToRemove, posts) {

        const deferred = new $.Deferred();

        const url = `/api/landscape/${RivalIQ.state.landscape.id}/postTagAssociations`;
        $.ajax({
            type: 'PUT',
            url: url,
            data: {
                post_tags_to_add: postTagsToAdd,
                post_tags_to_remove: postTagsToRemove,
                posts: posts
            },
            success: function () {
                RivalIQ.apps.SocialPosts.data.invalidateAllSocialPostsCaches();
                RivalIQ.apps.Insights.data.post.invalidateCaches();
                RivalIQ.postTags.data.PostTags.invalidateCaches();

                RivalIQ.postTags.data.PostTags.trigger('postTag:application:saved');
                deferred.resolve();
            },
            error: deferred.reject
        });

        return deferred;
    };
});
